import { CompanyPage } from '../components/pages'

export default CompanyPage
